export class Athlete {
    firstName: string;
    lastName: string;
    id: string;
    nationality: string;
    prone: ShootingPattern;
    standing: ShootingPattern;
    alternativeProne?: ShootingPattern[];
    alternativeStanding?: ShootingPattern[];
}

export class ShootingPattern {
    pattern: string;
    name: string;
}